import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import MobileHorizontalScrollerBox from '../boxes/MobileHorizontalScrollerBox';
import { useQuickFilterButtons } from '../../hooks';
import useIsMobile from '../../hooks/useIsMobile';

const FingoQuickFilter = ({ states, setStates, buttonsToShow, showDivider }) => {
  const isMobile = useIsMobile('tablet');
  const selectableButtons = useQuickFilterButtons();
  const buttons = useMemo(() => selectableButtons, [selectableButtons]);
  const [isActive, setIsActive] = useState({});
  const eraser = useMemo(() => ({
    ...states,
    ...buttons.map(({ key, defaultValue }) => ({ [key]: defaultValue })),
  }), [states]);
  const updateIsActive = (actualStates) => {
    setIsActive(
      Object.assign(...buttons.map(({ id, getIsActive }) => ({ [id]: getIsActive(actualStates) }))),
    );
  };
  const handleOnClick = useCallback((id, key, value) => () => {
    /* Change the external-hook filter */
    if (isActive[id]) {
      setStates({ ...eraser, [key]: null });
    } else {
      setStates({ ...eraser, [key]: value });
    }
    /* Change the colors of buttons */
  }, [isActive, eraser, setStates]);
  useEffect(() => {
    updateIsActive(states);
  }, [states]);
  return (
    <MobileHorizontalScrollerBox isMobile={isMobile}>
      { buttons.filter(({ id }) => buttonsToShow.some(
        (buttonToShow) => id.includes(buttonToShow),
      )).map((button) => {
        const { id, key, value, title, color, EndIcon, mobileTitle, className } = button;
        return (
          <Button
            key={`quick-filter-${id}`}
            id={`quick-filter-${id}`}
            variant="quickFilter"
            size="adaptative"
            className={isActive[id] ? 'Mui-selected' : ''}
            startIcon={<EndIcon className={className} sx={{ color: isActive[id] ? 'white' : color }} fontSize="small" />}
            onClick={handleOnClick(id, key, value)}
          >
            <Typography
              variant={isMobile ? 'small_1' : 'small_2'}
              fontWeight={500}
              sx={{ whiteSpace: 'nowrap' }}
            >
              {isMobile ? mobileTitle : title}
            </Typography>
          </Button>
        );
      })}
      {showDivider && (
      <Divider orientation="vertical" variant="middle" sx={{ height: '32px', alignSelf: 'center' }} flexItem />
      )}
    </MobileHorizontalScrollerBox>
  );
};

FingoQuickFilter.propTypes = {
  setStates: PropTypes.func.isRequired,
  states: PropTypes.shape().isRequired,
  buttonsToShow: PropTypes.arrayOf(PropTypes.string),
  showDivider: PropTypes.bool,
};

FingoQuickFilter.defaultProps = {
  buttonsToShow: [],
  showDivider: true,
};

export default FingoQuickFilter;
